import { render, staticRenderFns } from "./TabVideoCourseexplanation.vue?vue&type=template&id=60634454"
import script from "../../../services/teacher/VideoCourseTab/tab-videocourseexplanation.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/VideoCourseTab/tab-videocourseexplanation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports